import { extendTailwindMerge } from "tailwind-merge";

// Later classes win, so callers can override a component's defaults with className.
const merge = extendTailwindMerge({
  extend: {
    theme: {
      radius: ["field", "tile", "card", "bubble", "tail", "panel", "sheet"],
      shadow: ["bubble", "fab", "menu", "lift", "dock", "float"],
    },
  },
});

export function cn(...parts: Array<string | false | null | undefined>) {
  return merge(parts.filter(Boolean).join(" "));
}

// One focus ring for every interactive element: blue, offset from the edge.
export const focusRing =
  "outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue";

export function initialsOf(name: string) {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const first = words[0]?.[0] ?? "";
  const last = words.length > 1 ? (words[words.length - 1]?.[0] ?? "") : "";
  return (first + last).toUpperCase();
}
